'use client';

import { PrismicRichText } from '@prismicio/react';
import { FC } from 'react';
import { Content } from '@prismicio/client';
import { Cards, StaticCards } from '../index';

import { useVisible } from '@/hooks';
import { Button } from '@/components';
import { ProspectData } from '@/types/salesforce';

import styles from './styles.module.scss';
import QuestionCards from '../QuestionCards/QuestionCards';

type Props = {
  slice: Content.BenefitsSlice;
  prospect?: ProspectData;
};

export const BenefitsInner: FC<Props> = ({ slice, prospect }) => {
  const [isVisible, id] = useVisible();

  const isVisibleStyles = isVisible ? styles.isVisible : '';

  const isSubtitle =
    slice.variation === 'default' ||
    slice.variation === 'static' ||
    slice.variation === 'staticWhiteBackground' ||
    slice.variation === 'engineLanding';

  const hasLink = slice.variation === 'withoutSubtitleLink';

  const isStaticCardsVariation =
    slice.variation === 'static' || slice.variation === 'staticWhiteBackground';

  const isQuestionsVariation = slice.variation === 'questions';

  return (
    <div className={`${styles.inner} ${styles[slice.variation]}`} id={id}>
      {slice.variation === 'questions' ? (
        <div className={styles.titleWrapper}>
          <div className={`${styles.title} ${styles.desktopTitle}`}>
            <PrismicRichText field={slice.primary.title} />
          </div>
          <div className={`${styles.title} ${styles.mobileTitle}`}>
            <PrismicRichText field={slice.primary.mobile_title} />
          </div>
          <p className={styles.subtitle}>{slice.primary.subtitle}</p>
          <Button
            link={slice.primary.link}
            text={slice.primary.link_text}
            styles={styles.button}
            isArrow
          />
        </div>
      ) : (
        <>
          <div
            className={`${styles.title} ${isVisibleStyles} ${styles[slice.variation]}`}
          >
            <PrismicRichText field={slice.primary.title} />
          </div>

          {isSubtitle && (
            <p
              className={`${styles.subtitle} ${isVisibleStyles} ${styles[slice.variation]}`}
            >
              {slice.primary.subtitle}
            </p>
          )}
        </>
      )}
      {isStaticCardsVariation ? (
        <StaticCards cards={slice.primary.cards} />
      ) : isQuestionsVariation ? (
        <QuestionCards
          cards={slice.primary.cards}
          buttonText={slice.primary.link_text}
          buttonLink={slice.primary.link}
          labelText={slice.primary.label}
        />
      ) : (
        <Cards
          cards={slice.primary.cards}
          variation={slice.variation}
          prospect={prospect}
        />
      )}
      {hasLink && (
        <div className={styles.linkWrapper}>
          <Button
            link={slice.primary.link}
            text={slice.primary.link_text}
            variation="white"
          />
        </div>
      )}
    </div>
  );
};
